import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "./queryKeys";
import {
  getInfraTypes,
  InfraType,
} from "~/lib/server-functions/get-infra-types";

export const useInfraTypes = (ids?: number[] | string[]) => {
  // Check if the array contains numbers or strings
  const isNames = ids && ids.length > 0 && typeof ids[0] === "string";

  return useQuery<InfraType[]>({
    queryKey: [QUERY_KEYS.INFRA_TYPES, ids],
    queryFn: async () => {
      if (isNames) {
        const infraTypes = await getInfraTypes({
          data: { names: ids as string[] },
        });
        return infraTypes;
      } else {
        const infraTypes = await getInfraTypes({
          data: ids ? { ids: ids as number[] } : undefined,
        });
        return infraTypes;
      }
    },
  });
};
